// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Hyzt","right":"styles_right__36ZrW"};